<template>
  <div>
    <template v-if="selectedAccount">
      <div
        class="card card-select btn-light"
        @click="handleSelectedAccountClick()"
      >
        <div class="card-body">
          <account-label
            :account="selectedAccount"
            @click="handleSelectedAccountClick()"
          />
        </div>
      </div>
    </template>
    <template v-else>
      <div class="card" @click="handleSelectedAccountClick()">
        <div class="card-body">Selecione uma conta ou caixa</div>
      </div>
    </template>

    <b-modal
      ref="modal"
      title="Selecione uma conta ou caixa"
      header-class="border-bottom-0"
      size="xs"
      hide-footer
    >
      <template v-for="account in accounts">
        <div class="card" @click="selectAccount(account)" :key="account.id">
          <div class="card-body">
            <account-label :account="account" />
          </div>
        </div>
        <br />
      </template>
    </b-modal>
  </div>
</template>

<script>
  import accountLabel from "@/components/account/sections/AccountLabel";

  export default {
    components: { accountLabel },

    props: {
      value: {},
      onlyAllowed: {
        default: true
      },
      status: {
        default: 1
      },
      exceptId: {
        default: null
      }
    },

    data: () => ({
      selectedAccount: null
    }),

    async created() {
      await this.$store.dispatch("account/getAccounts", {});

      this.selectedAccount = this.value;
    },

    computed: {
      accounts() {
        if (this.exceptId == null) {
          return this.onlyAllowed
            ? this.$store.getters["account/allowedAccounts"]
            : this.$store.state.account.accounts;
        } else {
          return this.onlyAllowed
            ? this.$store.getters["account/allowedAccounts"].filter(account => {
                return account.id != this.exceptId;
              })
            : this.$store.state.account.accounts.filter(account => {
                return account.id != this.exceptId;
              });
        }
      }
    },

    watch: {
      value() {
        this.selectedAccount = this.value;
      }
    },

    methods: {
      selectAccount(account) {
        this.selectedAccount = account;
        this.$refs.modal.hide();
        this.$emit("input", account);
      },

      handleSelectedAccountClick() {
        this.$refs.modal.show();
      }
    }
  };
</script>

<style>
.card-select {
  cursor: pointer;
}

/* .card-selected {
  border-color: #8bc34a;
}

.card-selectable:hover {
  border-color: #8bc34a;
} */
</style>